<span
  class="state-column-point"
  [ngClass]="[row[columnConfig.id] ?? '', $any(columnConfig).stateType ?? 'circle']"
  [style.backgroundColor]="getColor($any(columnConfig), row)"
  [matTooltip]="'REVIEW_STATE.' + row[columnConfig.id] | translate"
  [matTooltipClass]="['table-tooltip', 'light']"
  [matTooltipDisabled]="$any(columnConfig).disableTooltip || !row[columnConfig.id]"
></span>
